/*
 * This illustrates how to modify the LoadOrdersHandler in a number of different ways.
 * The LoadOrdersHandler is used by the order history page to load order data
 */

import{ addToChainAfter,addToChainBefore} from "@insite/client-framework/HandlerCreator";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddLinesToCart";
import useCurrentPageDetails, {removePageDetailsFromCookie} from "@MasterBluePrint/Common/Hooks/useCurrentPageDetails";

addToChainBefore(chain, RequestDataFromApi,   props =>
{
    useCurrentPageDetails(props.getState());
});
addToChainAfter(chain, RequestDataFromApi,   props =>
{    
    removePageDetailsFromCookie();
});


